import { jsx as g } from "react/jsx-runtime";
import { useState as i, useEffect as a, useCallback as h, createContext as p, useMemo as v, useContext as T } from "react";
const m = "barel:theme", u = "barel:motion", E = `(function () {
  try {
    var t = localStorage.getItem('${m}') || 'system';
    var resolved = t === 'system'
      ? (matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark')
      : t;
    if (resolved === 'light') {
      document.documentElement.setAttribute('data-theme', 'light');
    } else {
      document.documentElement.removeAttribute('data-theme');
    }

    var m = localStorage.getItem('${u}') || 'auto';
    var rm = m === 'reduce' || (m === 'auto' && matchMedia('(prefers-reduced-motion: reduce)').matches);
    if (rm) {
      document.documentElement.setAttribute('data-motion', 'reduce');
    } else {
      document.documentElement.removeAttribute('data-motion');
    }
  } catch (e) {
    /* localStorage not available — fall back to dark + auto motion */
  }
})();`;
function $() {
  return `<script>${E}<\/script>`;
}
const f = (e) => e === "light" || e === "dark" || e === "system", S = () => {
  if (typeof window > "u") return "system";
  try {
    const e = window.localStorage.getItem(m);
    return f(e) ? e : "system";
  } catch {
    return "system";
  }
}, M = () => {
  if (typeof window > "u") return "dark";
  try {
    return window.matchMedia("(prefers-color-scheme: light)").matches ? "light" : "dark";
  } catch {
    return "dark";
  }
}, b = (e, o) => e === "system" ? o : e, A = (e) => {
  typeof document > "u" || (e === "light" ? document.documentElement.setAttribute("data-theme", "light") : document.documentElement.removeAttribute("data-theme"));
};
function k() {
  const [e, o] = i(() => S()), [r, c] = i(() => M()), d = b(e, r);
  a(() => {
    A(d);
  }, [d]), a(() => {
    if (typeof window > "u") return;
    let t;
    try {
      t = window.matchMedia("(prefers-color-scheme: light)");
    } catch {
      return;
    }
    const n = (s) => {
      c(s.matches ? "light" : "dark");
    };
    return t.addEventListener?.("change", n), () => {
      t.removeEventListener?.("change", n);
    };
  }, []), a(() => {
    if (typeof window > "u") return;
    const t = (n) => {
      if (n.key !== m) return;
      const s = f(n.newValue) ? n.newValue : "system";
      o(s);
    };
    return window.addEventListener("storage", t), () => {
      window.removeEventListener("storage", t);
    };
  }, []);
  const l = h((t) => {
    if (o(t), typeof window < "u")
      try {
        window.localStorage.setItem(m, t);
      } catch {
      }
  }, []);
  return { theme: e, resolvedTheme: d, setTheme: l };
}
const w = (e) => e === "auto" || e === "reduce", R = () => {
  if (typeof window > "u") return "auto";
  try {
    const e = window.localStorage.getItem(u);
    return w(e) ? e : "auto";
  } catch {
    return "auto";
  }
}, x = () => {
  if (typeof window > "u") return !1;
  try {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  } catch {
    return !1;
  }
}, L = (e, o) => e === "reduce" ? !0 : o, I = (e) => {
  typeof document > "u" || (e ? document.documentElement.setAttribute("data-motion", "reduce") : document.documentElement.removeAttribute("data-motion"));
};
function C() {
  const [e, o] = i(() => R()), [r, c] = i(() => x()), d = L(e, r);
  a(() => {
    I(d);
  }, [d]), a(() => {
    if (typeof window > "u") return;
    let t;
    try {
      t = window.matchMedia("(prefers-reduced-motion: reduce)");
    } catch {
      return;
    }
    const n = (s) => {
      c(s.matches);
    };
    return t.addEventListener?.("change", n), () => {
      t.removeEventListener?.("change", n);
    };
  }, []), a(() => {
    if (typeof window > "u") return;
    const t = (n) => {
      if (n.key !== u) return;
      const s = w(n.newValue) ? n.newValue : "auto";
      o(s);
    };
    return window.addEventListener("storage", t), () => {
      window.removeEventListener("storage", t);
    };
  }, []);
  const l = h((t) => {
    if (o(t), typeof window < "u")
      try {
        window.localStorage.setItem(u, t);
      } catch {
      }
  }, []);
  return { motion: e, resolvedReduced: d, setMotion: l };
}
const y = p(null);
function O({ children: e }) {
  const o = k(), r = C(), c = v(
    () => ({
      theme: o.theme,
      resolvedTheme: o.resolvedTheme,
      setTheme: o.setTheme,
      motion: r.motion,
      resolvedReduced: r.resolvedReduced,
      setMotion: r.setMotion
    }),
    [
      o.theme,
      o.resolvedTheme,
      o.setTheme,
      r.motion,
      r.resolvedReduced,
      r.setMotion
    ]
  );
  return /* @__PURE__ */ g(y.Provider, { value: c, children: e });
}
function _() {
  const e = T(y);
  if (!e)
    throw new Error("useThemeContext must be used within a <ThemeProvider>");
  return e;
}
export {
  u as M,
  m as T,
  y as a,
  O as b,
  E as c,
  $ as d,
  k as e,
  _ as f,
  C as u
};
//# sourceMappingURL=ThemeProvider-D7MXCkXI.js.map
